function getDataFromBaseFields(element: Element, formData: [string, string | string[]][]) {
  if (element instanceof HTMLInputElement) {
    if (element.type == "radio" && !element.checked) {
      return true;
    }
    if (element.type == "checkbox" && !element.checked) {
      return true;
    }
    if (element.type == "checkbox" && element.checked) {
      const value = formData.find(x => x[0] == element.name);
      if (value !== undefined) {
        const index = formData.indexOf(value);

        if (Array.isArray(value[1])) {
          value[1].push(element.value);
          formData[index] = value;
          return true;
        }
        value[1] = [value[1]];
        formData[index] = value;
        return true;
      }
      formData.push([element.name, element.value]);
      return true;
    }
  }

  if (
    element instanceof HTMLInputElement
    || element instanceof HTMLSelectElement
    || element instanceof HTMLTextAreaElement
    || element instanceof HTMLButtonElement
  ) {
    formData.push([element.name, element.value]);
    return true;
  }
  return false;
}

export function getFormData(form: HTMLFormElement): [string, string | []][] {
  const formData = [] as [string, string][];
  for (let i = 0; i < form.elements.length; i++) {
    const element = form.elements[i];
    if (getDataFromBaseFields(element, formData)) {
      continue;
    }
  }
  return formData;
}
